import React from "react";
import { useNavigate } from "react-router-dom";
import { Paper, Box, Typography, Stack, Button } from "@mui/material";
import { PersonAdd as PersonAddIcon } from "../icons";
import { T } from "../routes/Translate";
import { brandColors } from "../theme";

// Invitación a crear cuenta para visitantes sin sesión en las páginas
// públicas (tiendas, publicaciones, páginas institucionales).
const GuestJoinBanner = ({ sx }) => {
  const navigate = useNavigate();

  return (
    <Paper
      elevation={3}
      sx={{
        mb: 3, p: 2.5, borderRadius: 3,
        background: `linear-gradient(90deg, ${brandColors.primary} 0%, ${brandColors.primaryHover} 100%)`,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        flexWrap: "wrap", gap: 2,
        ...sx,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <PersonAddIcon sx={{ color: "white", fontSize: 32 }} />
        <Box>
          <Typography variant="subtitle1" sx={{ color: "white", fontWeight: 700 }}>
            <T>Únete a Notiline</T>
          </Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.85)" }}>
            <T>Crea tu cuenta gratis y accede a ofertas, eventos, viajes y más.</T>
          </Typography>
        </Box>
      </Box>
      <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => navigate("/login")}
          sx={{ color: "white", borderColor: "white", "&:hover": { borderColor: "white", bgcolor: "rgba(255,255,255,0.1)" } }}
        >
          <T>Iniciar sesión</T>
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={() => navigate("/register")}
          sx={{ bgcolor: "white", color: brandColors.primary, fontWeight: 700, "&:hover": { bgcolor: "#e8e8e8" } }}
        >
          <T>Registrarse</T>
        </Button>
      </Stack>
    </Paper>
  );
};

export default GuestJoinBanner;
